export var LOGO_WRAPPER_CLASSNAME = 'lg:mr-40';